/* @flow */
export const SET_PACKETS_CHART_INTERVAL = 'SET_PACKETS_CHART_INTERVAL'
export const SET_JOIN_REQUESTS_CHART_INTERVAL = 'SET_JOIN_REQUESTS_CHART_INTERVAL'
export const SET_CRC_CHART_INTERVAL = 'SET_CRC_CHART_INTERVAL'
export const SET_MISSED_PACKETS_CHART_INTERVAL = 'SET_MISSED_PACKETS_CHART_INTERVAL'
export const SET_SIGNAL_CHART_INTERVAL = 'SET_SIGNAL_CHART_INTERVAL'

const initialState = () => ({
  packetsChartInterval: 'daily',
  joinRequestsChartInterval: 'daily',
  crcChartInterval: 'hourly',
  missedPacketsChartInterval: 'daily',
  signalChartInterval: 'daily',
})

export default {
  state: initialState(),
  mutations: {
    [SET_PACKETS_CHART_INTERVAL](state: Object, payload: Object) {
      state.packetsChartInterval = payload.interval
    },
    [SET_JOIN_REQUESTS_CHART_INTERVAL](state: Object, payload: Object) {
      state.joinRequestsChartInterval = payload.interval
    },
    [SET_CRC_CHART_INTERVAL](state: Object, payload: Object) {
      state.crcChartInterval = payload.interval
    },
    [SET_MISSED_PACKETS_CHART_INTERVAL](state: Object, payload: Object) {
      state.missedPacketsChartInterval = payload.interval
    },
    [SET_SIGNAL_CHART_INTERVAL](state: Object, payload: Object) {
      state.signalChartInterval = payload.interval
    },
  },
  actions: {},
}



// WEBPACK FOOTER //
// ./src/store/ui.js